export default {
  init() {
    
  },
  finalize() {
	setTimeout(
		function(){
			$('#example').DataTable({
				"paging": false,
				//"searching": false,
				searchPane: {
					container: '.searchPanes',
					threshold: 0,
				},
			});
		}, 500);
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/files.js